<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container">
        <a class="navbar-brand" [routerLink]="['/landing']">
            <img src="assets/img/taskradar.png" alt="TaskRadar Logo" height="40">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav ms-auto">
                <li class="nav-item">
                    <a class="nav-link nav-link-lg d-flex align-items-center gap-2" routerLinkActive="active" [routerLink]="['/features']">
                        <i class="fa-solid fa-list-check" aria-hidden="true"></i>
                        <span>Funktionen</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-lg d-flex align-items-center gap-2" routerLinkActive="active" [routerLink]="['/price']">
                        <i class="fa-solid fa-tag" aria-hidden="true"></i>
                        <span>Preis</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="btn btn-primary d-flex align-items-center gap-2" routerLink="/login">
                        <i class="fa-solid fa-right-to-bracket" aria-hidden="true"></i>
                        <span>Anmelden</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</nav>
